<template>
  <span :class="className">
    <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" fill="white" />
      <path :fill="fillColor" d="M1.5 3V13.5C1.5 14.0523 1.94772 14.5 2.5 14.5H12.5" stroke="#1A73E8" stroke-width="1.5"
        stroke-linecap="round" />
      <path :fill="fillColor"
        d="M4 11V3C4 2.44772 4.44772 2 5 2H13C13.5523 2 14 2.44772 14 3V11C14 11.5523 13.5523 12 13 12H5C4.44772 12 4 11.5523 4 11Z"
        stroke="#1A73E8" stroke-width="1.5" />
    </svg>
  </span>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'FoldersIcon',
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    },

    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
